import React from 'react'
import Helmet from 'react-helmet'

export function GtmDataLayerSetup({ contentType, templateType }) {
	return (
		<Helmet>
			<script>
				{`
				 	window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						contentType: "${contentType}",
						templateType: "${templateType}",
						URL: window.location.href,
					})
				`}
			</script>
		</Helmet>
	)
}
